import {
  EConfiguratorQuestionType,
  EConfiguratorStep,
  EProjectScope,
  IConfiguratorStep
} from '../models/configurator.model';
import { emailFormatValidator } from '../helpers/configurator-rules.helper';
import {
  configuratorIcon,
  EXTERIOR_WORK_NONE,
  EXTERIOR_WORK_OPTIONS,
  PROJECT_GOAL_OPTIONS,
  PROJECT_SCOPE_OPTIONS,
  TRADE_OPTIONS
} from './configurator-options.data';
import { isScope } from './configurator-predicates';
import { PROPERTY_STEP_SECTIONS } from './property-step.config';
import { WORKS_STEP_SECTIONS } from './works-step.config';
import { BUDGET_STEP_SECTIONS } from './budget-step.config';
import { EQUIPMENT_STEP_SECTIONS } from './equipment-step.config';
import { CONTACT_STEP_SECTIONS } from './contact-step.config';
import { PHOTOS_STEP_SECTIONS } from './photos-step.config';

const T = 'ProjectConfiguratorV2.Questions';

/**
 * Wizard definition: steps → sections → questions. Steps and questions are filled in stage by stage
 * (see docs/project-configurator-v2/PLAN.md). A step without visible sections shows the "nothing to ask" card.
 */
export const CONFIGURATOR_STEPS: IConfiguratorStep[] = [
  {
    id: EConfiguratorStep.SCOPE,
    enabled: true,
    kickerNote: 'ProjectConfiguratorV2.Steps.scope.kickerNote',
    sections: [
      {
        id: 'scope',
        questions: [
          {
            id: 'projectScope',
            type: EConfiguratorQuestionType.TILES,
            summaryLabel: `${T}.projectScope.summary`,
            options: PROJECT_SCOPE_OPTIONS,
            columns: 4,
            required: true,
            requiredMessage: `${T}.projectScope.required`
          },
          {
            id: 'trades',
            type: EConfiguratorQuestionType.CHIPS,
            summaryLabel: `${T}.trades.summary`,
            label: `${T}.trades.label`,
            options: TRADE_OPTIONS,
            multiple: true,
            allowCustom: true,
            show: isScope(EProjectScope.SINGLE_WORKS)
          },
          {
            id: 'exteriorWorks',
            type: EConfiguratorQuestionType.CHIPS,
            summaryLabel: `${T}.exteriorWorks.summary`,
            label: `${T}.exteriorWorks.label`,
            options: EXTERIOR_WORK_OPTIONS,
            multiple: true,
            exclusiveValues: [EXTERIOR_WORK_NONE],
            allowCustom: true,
            show: isScope(EProjectScope.EXTERIOR, EProjectScope.HOUSE)
          },
          {
            id: 'clientComment',
            type: EConfiguratorQuestionType.TEXTAREA,
            summaryLabel: `${T}.clientComment.summary`,
            label: `${T}.clientComment.label`,
            help: `${T}.clientComment.help`,
            placeholder: `${T}.clientComment.placeholder`
          },
          {
            id: 'projectGoal',
            type: EConfiguratorQuestionType.CHIPS,
            summaryLabel: `${T}.projectGoal.summary`,
            label: `${T}.projectGoal.label`,
            options: PROJECT_GOAL_OPTIONS,
            allowCustom: true
          }
        ]
      },
      {
        id: 'keepDraft',
        icon: configuratorIcon('chat'),
        title: 'ProjectConfiguratorV2.Sections.keepDraft',
        questions: [
          {
            id: 'email',
            type: EConfiguratorQuestionType.EMAIL,
            summaryLabel: `${T}.email.summary`,
            label: `${T}.email.label`,
            help: `${T}.email.help`,
            placeholder: `${T}.email.placeholder`,
            required: true,
            requiredMessage: `${T}.email.required`,
            maxLength: 100,
            validate: emailFormatValidator(`${T}.email.invalid`)
          }
        ]
      }
    ]
  },
  { id: EConfiguratorStep.PROPERTY, enabled: true, sections: PROPERTY_STEP_SECTIONS },
  { id: EConfiguratorStep.WORKS, enabled: true, sections: WORKS_STEP_SECTIONS },
  { id: EConfiguratorStep.EQUIPMENT, enabled: true, sections: EQUIPMENT_STEP_SECTIONS },
  {
    id: EConfiguratorStep.PHOTOS,
    enabled: true,
    kickerNote: 'ProjectConfiguratorV2.Steps.photos.kickerNote',
    sections: PHOTOS_STEP_SECTIONS
  },
  { id: EConfiguratorStep.BUDGET, enabled: true, sections: BUDGET_STEP_SECTIONS },
  { id: EConfiguratorStep.CONTACT, enabled: true, sections: CONTACT_STEP_SECTIONS },
  { id: EConfiguratorStep.REVIEW, enabled: true, sections: [] }
];
